import React, {useContext, useEffect, useState} from 'react';
import AccountForm from '../../views/account/account-form';
import {inject, observer} from 'mobx-react';
import AttributesTable from '../../views/attributes/attributes-table';
import AttributesForm from '../../views/attributes/attributes-form';
import {useIntl} from 'react-intl';
import useAlerts from '../../hooks/use-alerts';
import {ModalContext} from '../../apiContexts';

const AccountContainer = (props) => {
    const intl = useIntl();
    const {toast} = useAlerts();
    const {showModalLoading, isModalLoading} = useContext(ModalContext);
    const [view, setView] = useState('accountForm');
    const [editingAttr, setEditingAttr] = useState(false);
    const currentUser = props.auth.user;
    const coordinateFormats = props.coordinateFormats.listAsOptions;

    useEffect(() => {
        props.auth.revalidateUser();
    }, []);

    const updateRegister = async (data, afterTo = 'accountForm') => {
        try {
            showModalLoading(true);
            await props.auth.updateUser(data);
            setView(afterTo);
            toast.success(intl.formatMessage({id: 'sharedUpdatedSuccess'}));
        } catch (e) {
            toast.errorStatus(e);
        } finally {
            showModalLoading(false);
        }
    };

    // TODO: check deprecation
    const showAttributes = (data) => {
        // setCurrentUser(data);
        setView('attributeList');
    };

    const attributeForm = (data) => {
        setEditingAttr(data);
        setView('attributeForm');
    };

    const removeAttribute = async (data, key) => {
        delete data.attributes[key];
        await updateRegister(data, 'accountForm');
    };

    // TODO: check deprecation
    const backToAccount = (data) => {
        // setCurrentUser(data);
        setView('groupForm');
    };

    return (
        <>
            {
                {
                    accountForm: (
                        <AccountForm
                            data={currentUser}
                            profile={props.auth.profile}
                            coordinateFormats={coordinateFormats}
                            attributes={showAttributes}
                            updateRegister={updateRegister}
                            loading={isModalLoading}
                        />
                    ),
                    attributeList: (
                        <AttributesTable
                            cancel={backToAccount}
                            attributeForm={attributeForm}
                            removeAttribute={removeAttribute}
                            data={currentUser}
                        />
                    ),
                    attributeForm: (
                        <AttributesForm
                            cancel={() => setView('attributeList')}
                            data={Object.assign({}, currentUser)}
                            edit={editingAttr}
                            updateRegister={updateRegister}
                        />
                    ),
                }[view]
            }
        </>
    );
};

const mapping = ({store}) => ({
    auth: store.auth,
    mapType: store.mapType,
    coordinateFormats: store.coordinateFormats,
});

export default inject(mapping)(observer(AccountContainer));
